import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { AntdThemeProvider } from './components/AntdThemeProvider';
import { ProtectedRoute } from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import ProductGallery from './pages/ProductGallery';
import ProductMovements from './pages/ProductMovements';
import AddProduct from './pages/AddProduct';
import PriceBulkUpdate from './pages/PriceBulkUpdate';
import PriceBulkUpdatePercent from './pages/PriceBulkUpdatePercent';
import Stock from './pages/Stock';
import PrintLabels from './pages/PrintLabels';
import Documents from './pages/Documents';
import AddDocument from './pages/AddDocument';
import Branches from './pages/Branches';
import Invoices from './pages/Invoices';
import Accounts from './pages/Accounts';
import Warehouses from './pages/Warehouses';
import Categories from './pages/Categories';
import ProductBrands from './pages/ProductBrands';
import UnitSets from './pages/UnitSets';
import Users from './pages/Users';
import Variants from './pages/Variants';
import LayoutComponent from './components/Layout';
import StockSettings from './pages/StockSettings';
import ProfitabilityReport from './pages/ProfitabilityReport';
import DetailedProfitabilityReport from './pages/DetailedProfitabilityReport';
import PersonelProfitReport from './pages/PersonelProfitReport';
import Vehicles from './pages/Vehicles';
import CashRegisters from './pages/CashRegisters';
import CashRegisterMovements from './pages/CashRegisterMovements';
import Expenses from './pages/Expenses';
import ServiceOrdersList from './pages/ServiceOrdersList';
import ServiceItems from './pages/ServiceItems';
import ExternalServiceItems from './pages/ExternalServiceItems';
import ComplaintItems from './pages/ComplaintItems';
import ServiceCustomers from './pages/ServiceCustomers';
import AddVehicleWithCustomer from './pages/AddVehicleWithCustomer';
import ServiceOrderFormPage from './pages/ServiceOrderFormPage';
import ViewServiceOrder from './pages/ViewServiceOrder';
import ServiceOrderCollection from './pages/ServiceOrderCollection';
import Payment from './pages/Payment';
import CustomerDebtors from './pages/CustomerDebtors';
import SupplierPayables from './pages/SupplierPayables';
import PaymentReport from './pages/PaymentReport';
import GeneralSettings from './pages/GeneralSettings';
import ServiceOrderNotifications from './pages/ServiceOrderNotifications';
import SmsLog from './pages/SmsLog';
import ExpenseTypes from './pages/ExpenseTypes';
import BankAccounts from './pages/BankAccounts';
import Ajanda from './pages/Ajanda';
import ImportStock from './pages/ImportStock';

function App() {
  return (
    <ThemeProvider>
      <AntdThemeProvider>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <LayoutComponent>
                  <Routes>
                    <Route path="/" element={<Navigate to="/dashboard" replace />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/products" element={<Products />} />
                    <Route path="/products/:id/movements" element={<ProductMovements />} />
                    <Route path="/productgallery" element={<ProductGallery />} />
                    <Route path="/products/add" element={<AddProduct />} />
                    <Route path="/products/edit/:id" element={<AddProduct />} />
                    <Route path="/products/price-bulk-update" element={<PriceBulkUpdate />} />
                    <Route path="/products/price-bulk-update-percent" element={<PriceBulkUpdatePercent />} />
                    <Route path="/stock" element={<Stock />} />
                    <Route path="/print-labels" element={<PrintLabels />} />
                    <Route path="/documents" element={<Documents />} />
                    <Route path="/documents/add" element={<AddDocument />} />
                    <Route path="/branches" element={<Branches />} />
                    <Route path="/invoices" element={<Invoices />} />
                    <Route path="/accounts" element={<Accounts />} />
                    <Route path="/warehouses" element={<Warehouses />} />
                    <Route path="/categories" element={<Categories />} />
                    <Route path="/product-brands" element={<ProductBrands />} />
                    <Route path="/unitsets" element={<Navigate to="/stock-settings?tab=unitsets" replace />} />
                    <Route path="/settings" element={<Navigate to="/stock-settings" replace />} />
                    <Route path="/variants" element={<Variants />} />
                    <Route path="/users" element={<Users />} />
                    <Route path="/reports/profit" element={<ProfitabilityReport />} />
                    <Route path="/reports/detailedprofit" element={<DetailedProfitabilityReport />} />
                    <Route path="/reports/personelprofit" element={<PersonelProfitReport />} />
                    <Route path="/stock-settings" element={<StockSettings />} />
                    <Route path="/vehicles" element={<Vehicles />} />
                    <Route path="/cash-registers" element={<CashRegisters />} />
                    <Route path="/cash-registers/:id/movements" element={<CashRegisterMovements />} />
                    <Route path="/bank-accounts" element={<BankAccounts />} />
                    <Route path="/expenses" element={<Expenses />} />
                    <Route path="/service-customers" element={<ServiceCustomers />} />
                    <Route path="/add-vehicle-with-customer" element={<AddVehicleWithCustomer />} />
                    <Route path="/service-orders" element={<ServiceOrdersList />} />
                    <Route path="/service-orders/add" element={<ServiceOrderFormPage />} />
                    <Route path="/service-orders/create" element={<Navigate to="/service-orders/add" replace />} />
                    <Route path="/service-orders/:id" element={<ServiceOrderFormPage />} />
                    <Route path="/service-orders/:id/view" element={<ViewServiceOrder />} />
                    <Route path="/service-orders/:id/collection" element={<ServiceOrderCollection />} />
                    <Route path="/payment" element={<Payment />} />
                    <Route path="/payment/report" element={<PaymentReport />} />
                    <Route path="/customerdept" element={<CustomerDebtors />} />
                    <Route path="/supplier-payables" element={<SupplierPayables />} />
                    <Route path="/service-items" element={<ServiceItems />} />
                    <Route path="/external-service-items" element={<ExternalServiceItems />} />
                    <Route path="/complaint-items" element={<ComplaintItems />} />
                    <Route path="/general-sms-settings" element={<GeneralSettings />} />
                    <Route path="/expense-types" element={<ExpenseTypes />} />
                    <Route path="/notifications" element={<ServiceOrderNotifications />} />
                    <Route path="/sms-log" element={<SmsLog />} />
                    <Route path="/ajanda" element={<Ajanda />} />
                    <Route path="/import-stock" element={<ImportStock />} />
                  </Routes>
                </LayoutComponent>
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
      </AntdThemeProvider>
    </ThemeProvider>
  );
}

export default App;
